import axios from '@/app/plugins/Axios'

export default new class BalancoService {

  listar() {
    return axios.get('balanco').then(response => response.data);
  }

  abrir(id) {
    return axios.get('/balanco/' + id).then(response => response.data);
  }

  salvar(balanco) {
    return axios.post('/balanco', balanco).then(response => response.data);
  }

  atualizar(balanco) {
    return axios.put('/balanco/'+ balanco.id, balanco).then(response => response.data);
  }

  excluir(id) {
    return axios.delete('/balanco/' + id).then(response => response.data);
  }

  adicionarItem(item) {
    return axios.post(`/balanco/${item.balanco_id}/item`, item).then(response => response.data);
  }

  listarItens(balanco) {
    return axios.get(`/balanco/${balanco.id}/itens`).then(response => response.data);
  }

  removerItem(item) {
    return axios.delete(`/balanco/item/${item.id}`).then(response => response.data);
  }

  iniciarBalanco(balanco_id) {
    return axios.put(`/balanco/${balanco_id}/iniciar`).then(response => response.data);
  }

  terminarBalanco(balanco_id) {
    return axios.put(`/balanco/${balanco_id}/terminar`).then(response => response.data);
  }
}
